import { CRUDProvider } from 'components/providers';
import { useTranslation } from 'react-i18next';
import { InvestmentResources } from 'services/resources/financial/investment';

import { Page } from './components/Page';

export const InvestmentPage: React.FC = (): JSX.Element => {
  const { t } = useTranslation('investments');

  return (
    <CRUDProvider
      allowPost
      companyFilter
      quote={t('page.quote')}
      resource={InvestmentResources}
      searchBy="email"
      title={t('page.title')}
    >
      <Page />
    </CRUDProvider>
  );
};
